import { useState } from 'react'
import { toast } from 'react-toastify'
import { SvgIcon, SvgType } from '../../../common/svgIcon/SvgIcon'
import { OnDemandAsides } from './styled'

const OnDemandNote = (props: any) => {
  const { sessionId } = props
  const [note, setNote] = useState(localStorage.getItem(sessionId) || '')

  const handleNoteChange = (e: any) => {
    setNote(e.target.value)
  }

  const handleNoteSubmit = (e: any) => {
    e.preventDefault()
    toast('Note saved!')
    localStorage.setItem(sessionId, note)
  }

  return (
    <OnDemandAsides>
      <div className="heading">
        <SvgIcon type={SvgType.EDITPROFILE} />
        <span className="headingTitle">Notes</span>
      </div>
      <form onSubmit={handleNoteSubmit}>
        <textarea
          name="note"
          id="note"
          rows={10}
          value={note}
          onChange={handleNoteChange}
        ></textarea>
        <button className="btn btn-danger btn-sm asideBtn" type="submit">
        <SvgIcon type={SvgType.UPLOAD} />
          <span>Save Note</span>
        </button>
      </form>
    </OnDemandAsides>
  )
}

export default OnDemandNote
